import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Box, styled } from "@mui/material";

import { useContext } from "react";

import { PATH } from "@/configs/router/routerConfig";
import { styleSheet } from "@/configs/styles";
import { SidebarContext } from "@/contexts/SidebarContext";
import useSize from "@/utils/useSize";
import { useTranslation } from "next-i18next";
import Link from "next/link";

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        width: 100%;
        padding-left: 15px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const LogoSignWrapper = styled(Box)(
  () => `
        width: 40px;
        height: 40px;
`
);

function Logo({ href = PATH.HOME_PAGE }: { href? }) {
  const { t } = useTranslation();
  const { menuState, setMenuState } = useContext(SidebarContext);
  const size = useSize();
  return (
    <div style={{ display: "flex", justifyContent: menuState ? "space-between" : "center", alignItems: "center" }}>
      {menuState && (
        <LogoWrapper href={href}>
          <LogoSignWrapper>
            <Box
              component="img"
              alt="logo"
              src="/Sellpath-logo.png"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block"
              }}
            />
          </LogoSignWrapper>
          <span style={{ ...styleSheet.textStyleBold, marginLeft: "10px" }}>{t("SELLPATH")}</span>
        </LogoWrapper>
      )}
      {size.width >= 1280 && (
        <div
          style={{ marginRight: menuState ? "20px" : "0px" }}
          onClick={() => {
            setMenuState(!menuState);
          }}
        >
          <Box
            sx={{
              width: "30px",
              height: "30px",
              borderRadius: "10px",
              background: (theme) =>
                theme.palette.mode === "dark" ? theme.colors.alpha.white[70] : theme.colors.alpha.white[100],
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: (theme) =>
                theme.palette.mode === "dark" ? theme.sidebar.menuIconColor : theme.sidebar.menuIconColor
            }}
          >
            {menuState ? <KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
          </Box>
        </div>
      )}
    </div>
  );
}

export default Logo;
